/* Built In Imports */

/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';


/* Services */
/**
 * MomFooter Component
 * @param {Object} section dato
 * @param {String} region
 * @param {String} lang
 * @returns {ReactElement} MomFooter Component
 */

const MomFooter = ({ section, region, lang }) => {
  return ( 
      <Box as="footer" id="footer" w="100%" bg="#0F0F0F" py="35px" h="auto">
        <Flex
          justifyContent="center"
          alignItems="center"
          flexWrap="wrap"
          flexDirection={{ base: 'column', md: 'row' }}
        >
          {section?.map(item => (
            <Box key={nanoid()} mr="25px">
              <StructuredTextParser
                str={render(item?.body)}
                fontSize={{ base: '14px', md: '16px' }}
                lineHeight={{ base: '21px', md: '24px' }}
                fontFamily="'Geist', sans-serif"
                color="#FFFFFF"
                my="10px"
                mt="0"
                region={region}
                lang={lang}
                textDecoration="none"
                sx={{
                  a: {
                    color: '#fff',
                    textDecoration: 'underline',
                  },
                  'a:hover': {
                    color: '#fff',
                    textDecoration: 'underline',
                  },
                  '.contactblock a[href^="https://"], a[href^=mailto]': {
                    color: '#fff',
                    textDecoration: 'underline',
                  },
                }}
              />
            </Box>
          ))}
        </Flex>
      </Box> 
  );
};

export default MomFooter;
